import React from 'react';
import styles from './Card.module.css';
import Word from '../components/Word';
import * as constants from '../constants';

const Card = (props) => {

    let cardStyle = 'cardClosed';
    let card = (
        <div className={styles.draw}
            onClick={props.drawCard}>
            <div>{constants.TEXT14}</div>
        </div>
    );
    if (props.card.drawn) {
        card = props.card.words.map((word, index) =>
            <Word
                key={word.text}
                id={index}
                word={word}
                guess={props.guess}
            />
        );
        cardStyle = 'cardDrawn';
    }
    return (
        <div className={[styles.card, styles[cardStyle]].join(' ')}>
            {card}
        </div>
    );
}

export default Card;